import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";

function MenuMore(props) {
  return React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }, props), React.createElement("path", {
    d: "M9 12a1 1 0 11-2 0 1 1 0 012 0zM9 4a1 1 0 11-2 0 1 1 0 012 0zM9 8a1 1 0 11-2 0 1 1 0 012 0z"
  }));
}

export { MenuMore };
//# sourceMappingURL=MenuMore.js.map